<template lang="html">
  <StandardDialog
    title='Confirmation'
    :color='color'>
    <template #activator='{ on }'>
      <slot name="activator" :on='on'>
        <v-btn v-on='on' class='default' dark>Activator</v-btn>
      </slot>
    </template>
    <template #main>
      <p class="font-weight-bold title">
        <slot name="main">
          Please Confirm
        </slot>
      </p>
      <p class="font-weight-bold font-italic subheading"><em>This action cannot be undone</em></p>
    </template>
    <template #actions='{ deactivate }'>
      <slot name="actions" :deactivate='deactivate'>
        <v-btn v-on='deactivate'>Close</v-btn>
      </slot>
    </template>
  </StandardDialog>
</template>

<script>
import StandardDialog from './StandardDialog'
export default {
  components: {
    StandardDialog
  },
  data: () => ({
    color: 'warning'
  })
}
</script>

<style lang="css" scoped>
</style>
